import {ReactNode} from "react";
import dayjs from "dayjs";
import {Text} from "@mantine/core";

type DateTimeProps = {
    dateTime: string | undefined | null;

    /**
     * Fallback to use if dateTime is undefined or null.
     * If not set, default fallback is '-'.
     * @author Kacper Faber
     */
    fallback?: string;

    /**
     * Render formatted date time.
     * Default to <Text>{text}</Text>.
     * @param text
     */
    render?: (text: string) => ReactNode;
}

function DateTime(props: DateTimeProps) {
    const text = props.dateTime
        ? dayjs(props.dateTime).format("YYYY-MM-DD HH:mm:ss")
        : (props.fallback ?? '-');

    if (props.render) {
        return <>{props.render(text)}</>;
    }

    return <Text children={text} />;
}

export default DateTime;